/**
 * Converts seconds to MM:SS format
 * @param seconds - Time in seconds
 * @returns String in MM:SS format
 */
export function secondsToMMSS(seconds: number | null | undefined): string {
  if (seconds === null || seconds === undefined || isNaN(seconds)) {
    return '00:00';
  }
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
}

/**
 * Converts MM:SS format to seconds
 * @param mmss - Time in MM:SS format (e.g., "05:30")
 * @returns Number of seconds, or null if invalid
 */
export function mmssToSeconds(mmss: string): number | null {
  if (!mmss || !mmss.trim()) {
    return null;
  }
  
  // Handle format like "5:30" or "05:30"
  const parts = mmss.trim().split(':');
  if (parts.length !== 2) {
    return null;
  }
  
  const mins = parseInt(parts[0], 10);
  const secs = parseInt(parts[1], 10);
  
  if (isNaN(mins) || isNaN(secs) || mins < 0 || secs < 0 || secs >= 60) {
    return null;
  }
  
  return mins * 60 + secs;
}

/**
 * Validates MM:SS format string
 * @param mmss - Time in MM:SS format
 * @returns true if valid, false otherwise
 */
export function isValidMMSS(mmss: string): boolean {
  return mmssToSeconds(mmss) !== null;
}




